import React from "react";
import PrepareMain from "../viewGuide/prepareMain/PrepareMain";

const Content = ({ basicGuideDetails, industryId, jobGuideIdentifier }) => {
  return (
    <div className="">
      {" "}
      <div className="mt-[7em]">
        <PrepareMain
          basicGuideDetails={basicGuideDetails}
          industryId={industryId}
          jobGuideIdentifier={jobGuideIdentifier}
        />
      </div>
    </div>
  );
};

export default Content;
